// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__cMx7v","stores":"App_stores__8BKc5","small":"App_small__2g_AN","big":"App_big__ltJT4","content":"App_content__YW6Pb","text":"App_text__dRA_O"};